import { render, staticRenderFns } from "./FormationsItem2.vue?vue&type=template&id=6c6c62be&"
import script from "./FormationsItem2.vue?vue&type=script&lang=js&"
export * from "./FormationsItem2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports